import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { DonorService } from "../services/donor.service";
import { ControlContainer, NgForm, NgModel } from "@angular/forms";
import { GoogleAnalyticsService } from "../services/google-analytics.service";

@Component({
    selector: "app-donor",
    templateUrl: "./donor.component.html",
    styleUrls: ["./donor.component.scss"],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DonorComponent implements OnInit {
  @Input() donorEditCommon: DonorService;
  @Input() form: NgForm;
  @Output() onNameChange = new EventEmitter<string>();
  private formStarted = false; 

  constructor(private _googleAnalytics: GoogleAnalyticsService) {}

  ngOnInit(): void {}

  showError(control: NgModel | null | undefined): boolean {
    return !!(this.form?.submitted || control?.touched || control?.dirty);
  }

  isFieldValid(control: NgModel | null | undefined): boolean {
    return !!control?.valid && this.showError(control);
  }

  isFieldInvalid(control: NgModel | null | undefined): boolean {
    return !!control?.invalid && this.showError(control);
  }

  onFormFieldFocus() {
    if (!this.formStarted) {
      this._googleAnalytics.customEventEmitter({
        eventName: 'Splash_form_donor_started',
        eventCategory: 'Form',
        eventAction: 'Start',
        eventLabel: 'User began filling out the donor form'
      });
      this.formStarted = true;
    }
  }
}
